import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
export const refreshTimeSlice = createSlice({
  name: 'refreshTime',
  initialState: {
    refreshTime: localStorage.getItem('refreshTime'),
  },
  reducers: {
    updateRefreshTime: (state, action) => {
      state.refreshTime = action.payload;
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { updateRefreshTime } = refreshTimeSlice.actions
export default refreshTimeSlice.reducer 
